var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"mt-16"},[_c('v-col',{staticClass:"mb-4"},[_c('h1',{staticClass:"display-1 font-weight-bold mx-1 mb-3"},[_vm._v("Authenticating")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }